import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBootCampAndFormList, getDashboardConfig, getDashboardData } from "../services/dashboard";
import { mapDashboardApiResponse } from "../utils/utils";

export const fetchDashboardData = createAsyncThunk(
  "dashboard/fetchData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getDashboardData(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchBootCampAndFormList = createAsyncThunk(
  "dashboard/fetchBootCamps",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBootCampAndFormList();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchDashboardConfig = createAsyncThunk(
  "dashboard/fetchDashboardConfig",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDashboardConfig();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const initialState = {
  isOpen: false,
  preselectedBootcampId: null,
  data: null,
  loading: false,
  optionsLoading: false,
  dashboardConfig:null,
  error: null,
  filterList: null,
  permissions: null
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    openDashboard: (state, action) => {
      state.isOpen = true;
      state.preselectedBootcampId = action.payload?.bootcampId || null;
      state.permissions = action.payload?.permissions || null;
    },
    closeDashboard: (state) => {
      state.isOpen = false;
      state.preselectedBootcampId = null;
      state.permissions = null;
    },
    clearDashboardData: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = mapDashboardApiResponse(action.payload);

      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBootCampAndFormList.pending, (state) => {
        state.optionsLoading = true;
        state.filterList = null;
      })
      .addCase(fetchBootCampAndFormList.fulfilled, (state, action) => {
        state.optionsLoading = false;
        state.filterList = action.payload;
      })
      .addCase(fetchBootCampAndFormList.rejected, (state) => {
        state.optionsLoading = false;
        state.filterList = null;
      })
      .addCase(fetchDashboardConfig.pending, (state) => {
        state.dashboardConfig = null;
      })
      .addCase(fetchDashboardConfig.fulfilled, (state, action) => {
        state.dashboardConfig = action.payload;
      })
      .addCase(fetchDashboardConfig.rejected, (state) => {
        state.dashboardConfig = null;
      })
  },
});

export const {
  openDashboard,
  closeDashboard,
  clearDashboardData,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
